class i18n {

    static about = `
    An simple set of name/value pairs to facilitate localizion.
    The maplet LOCALIZATIONS are loaded into this configuration.
    The mergeLocalizations method in [app](#app/app) handles the complexity of extending the contents
    of these values.

    Since these are just javascript objects it is possible to _.defaults to inject
    additional localizations.  For example:

    \`\`\`
    // load i18n
    import * as resx from "./i18n/common";

    // get target locale
    const i18n = resx(globals.locale);

    // overwrite settings
    i18n["bar"] = "bar";

    // ensure settings exist w/out overwriting existing ones
    _.defaults(i18n, {
        "addressLocationLine1": "<%=foo%>-<%=bar%>",
        "foo": "foo"
    });

    // consume
    function template(value: string, data = {}) {
        return _.template(value)(_.defaults({}, data, i18n));
    }

    // returns "My Foo-bar"
    template("<%= addressLocationLine1 %>", {foo: "My Foo"});
    \`\`\`
    
    `;

    static get(locale: string) {
        let factory = i18n[locale];
        if (!factory) {
            switch (locale.length) {
                case 5:
                    factory = i18n[locale] = Object.create(i18n.get(locale.substring(0, 2)));
                    break;
                case 2:
                default:
                    factory = i18n[locale] = {};
                    break;
            }
        }
        return factory;
    }
}

let getter = i18n.get;
export = getter;